export default class Sale {
    constructor(originSale) {
        if (originSale) {
            this.saleAddress = (originSale.saleAddress?originSale.saleAddress:'') + ' ' + (originSale.salePhone?originSale.salePhone:'') // 销方地址 ,
            this.saleAddress=this.saleAddress?this.saleAddress.trim():''
            this.saleBank = (originSale.saleBank?originSale.saleBank:'') + ' ' + (originSale.saleBankAccount?originSale.saleBankAccount:'') // 销方开户银行 ,
            this.saleBank=this.saleBank?this.saleBank.trim():''
            this.saleBankAccount = '' // 销方开户银行账号 ,
            this.saleCreditCode = originSale.saleCreditCode // 销方纳税人信用代码 ,
            this.saleId = originSale.saleId // 销方ID ,
            this.saleName = originSale.saleName // 销方名称 ,
            this.salePhone = '' // 销方电话 ,
            this.isChineseSecurity = originSale.isChineseSecurity
            this.tax4SaleAddress = originSale.saleAddress?originSale.saleAddress:''// 销方地址 ,
            this.tax4SalePhone = originSale.salePhone?originSale.salePhone:'' // 销方电话 ,
            this.tax4SaleBank = originSale.saleBank?originSale.saleBank:''// 销方开户银行 ,
            this.tax4SaleBankAccount = originSale.saleBankAccount?originSale.saleBankAccount:'' // 销方开户银行账号 ,
        } else {
            const userStr = localStorage.getItem('user_info')
            const sale = JSON.parse(userStr).sale || JSON.parse(userStr).supplierSale
            const sysUkeyList = JSON.parse(userStr).sysUkeyList[0]
            this.saleAddress = (sale.registerAddress + ' ' + sale.phone).trim() // 销方地址 ,
            this.saleBank = sale.saleBankAccount?(sale.saleBankAccount && sale.saleBankAccount.bankAndccount).trim():'' // 销方开户银行 ,
            this.saleBankAccount = '' // 销方开户银行账号 ,
            this.saleCreditCode = sale.saleCreditCode // 销方纳税人信用代码 ,
            this.saleId = sale.saleId || sale.supplierSaleId // 销方ID ,
            this.saleName = sale.saleName // 销方名称 ,
            this.salePhone = '' // 销方电话 ,
            this.isChineseSecurity = sale.isChineseSecurity
            this.tax4SaleAddress = sale.registerAddress?sale.registerAddress:''// 销方地址 ,
            this.tax4SalePhone = sale.phone?sale.phone:'' // 销方电话 ,
            this.tax4SaleBank = sale.saleBankAccount?sale.saleBankAccount.bank?sale.saleBankAccount.bank:'':''// 销方开户银行 ,
            this.tax4SaleBankAccount = sale.saleBankAccount?sale.saleBankAccount.bankAccount?sale.saleBankAccount.bankAccount:'':'' // 销方开户银行账号 ,
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/standModel/Sale.js